import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SharedModule } from "src/app/shared/shared.module";
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-balcao',
  templateUrl: './balcao.component.html',
  styleUrls: ['./balcao.component.scss'],
})
export class BalcaoComponent implements OnInit {

   safeUrl!: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit() {
    const url = environment.balcaoDash; 
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

}
